import { gql } from '@apollo/client';

export const GET_SUBSCRIPTION_FEATURE_TOGGLES = gql`
  query getSubscriptionFeatureToggles {
    app {
      id
      autoRenewReminderPopupEnabled
      sandboxSubscriptionSkuCheatEnabled
      sandboxSubscriptionSkuCheatUserIds
    }
  }
`;

export const UPDATE_SUBSCRIPTION_FEATURE_TOGGLES = gql`
  mutation updateSubscriptionFeatureToggles(
    $autoRenewReminderPopupEnabled: Boolean
    $sandboxSubscriptionSkuCheatEnabled: Boolean
    $sandboxSubscriptionSkuCheatUserIds: [String!]
  ) {
    updateAppFeatureToggles(
      input: {
        autoRenewReminderPopupEnabled: $autoRenewReminderPopupEnabled
        sandboxSubscriptionSkuCheatEnabled: $sandboxSubscriptionSkuCheatEnabled
        sandboxSubscriptionSkuCheatUserIds: $sandboxSubscriptionSkuCheatUserIds
      }
    ) {
      autoRenewReminderPopupEnabled
      sandboxSubscriptionSkuCheatEnabled
      sandboxSubscriptionSkuCheatUserIds
    }
  }
`;
